import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectCoverflow } from 'swiper/modules';
import { Calendar, Clock, ExternalLink, Download, Info } from 'lucide-react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import '../styles/WebinarCarousel.css';

const WebinarCarousel = ({ webinars, formatDate, formatTime }) => {
  return (
    <div className="webinar-carousel-container">
      <Swiper
        modules={[Navigation, Pagination, Autoplay, EffectCoverflow]}
        effect="coverflow"
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={1}
        spaceBetween={30}
        initialSlide={0}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 50,
          modifier: 1,
          slideShadows: false,
        }}
        autoplay={{
          delay: 3000,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        }}
        navigation={true}
        pagination={{ 
          clickable: true,
          dynamicBullets: true,
        }}
        className="webinar-swiper"
      >
        {webinars.map((webinar) => (
          <SwiperSlide key={webinar.id}>
            <div className="carousel-webinar-slide">
              <div className="carousel-webinar-card">
                <div className="carousel-webinar-header">
                  <h3>{webinar.title}</h3>
                </div>
                <div className="carousel-webinar-content">
                  <div className="carousel-webinar-top">
                    <p className="carousel-webinar-subtitle">{webinar.description}</p>
                    <div className="carousel-webinar-info">
                      <div className="carousel-info-item">
                        <Calendar size={18} />
                        <span>{formatDate(webinar.date)}</span>
                      </div>
                      <div className="carousel-info-item">
                        <Clock size={18} />
                        <span>
                          {formatTime(webinar.from_time)} - {formatTime(webinar.to_time)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="carousel-webinar-actions">
                    <a
                      href={webinar.registration_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="carousel-action-button primary"
                    >
                      <ExternalLink size={16} />
                      Register Now
                    </a>
                    <div className="carousel-secondary-actions">
                      {webinar.brochure_link && (
                        <a
                          href={webinar.brochure_link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="carousel-action-button secondary"
                        >
                          <Download size={16} />
                          Download Brochure
                        </a>
                      )}
                      {webinar.product_info_link && (
                        <a
                          href={webinar.product_info_link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="carousel-action-button secondary"
                        >
                          <Info size={16} />
                          Product Information
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default WebinarCarousel; 